/* Shared mobile-carousel driver for SAF homepage scroll rows.
   Drives position dots, a "swipe" hint, and optional auto-scroll for any
   element marked [data-saf-carousel]. Idempotent and theme-editor aware. */
(function () {
  if (window.__safCarouselLoaded) return;
  window.__safCarouselLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(track) {
    if (track.dataset.safCarouselInit) return;
    track.dataset.safCarouselInit = '1';

    var root = track.closest('.saf-carousel') || track.parentElement;
    var dotsWrap = root ? root.querySelector('[data-saf-dots]') : null;
    var hint = root ? root.querySelector('[data-saf-hint]') : null;
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;

    function trackLeft() { return track.getBoundingClientRect().left; }

    function currentIndex() {
      var base = trackLeft();
      var min = Infinity, idx = 0;
      items.forEach(function (el, i) {
        var d = Math.abs(el.getBoundingClientRect().left - base);
        if (d < min) { min = d; idx = i; }
      });
      return idx;
    }

    function scrollToIndex(i) {
      var el = items[i];
      if (!el) return;
      var delta = el.getBoundingClientRect().left - trackLeft();
      track.scrollTo({ left: track.scrollLeft + delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    // Build position dots
    var dots = [];
    if (dotsWrap) {
      items.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'saf-carousel__dot';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.addEventListener('click', function () { scrollToIndex(i); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function update() {
      var idx = currentIndex();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (hint) hint.classList.add('is-hidden');
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(update);
    }, { passive: true });
    update();

    // Optional auto-scroll
    if (track.dataset.autoscroll === 'true' && !reduceMotion) {
      var speed = parseInt(track.dataset.autoscrollSpeed, 10) || 4000;
      var timer = null, paused = false;

      function scrollable() { return track.scrollWidth - track.clientWidth > 4; }
      function tick() {
        if (paused || !scrollable()) return;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollToIndex(Math.min(currentIndex() + 1, items.length - 1));
        }
      }
      function start() { if (!timer) timer = window.setInterval(tick, speed); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

      ['pointerenter', 'touchstart', 'focusin'].forEach(function (e) {
        track.addEventListener(e, function () { paused = true; stop(); }, { passive: true });
      });
      ['pointerleave', 'touchend', 'focusout'].forEach(function (e) {
        track.addEventListener(e, function () { paused = false; start(); }, { passive: true });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
        }, { threshold: 0.2 }).observe(track);
      } else {
        start();
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-saf-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
